// App.js
import React, { useState, useRef } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import Pricing from './components/Pricing';
import Testimonials from './components/Testimonials';
import FAQ from './components/FAQ';
import DemoForm from './components/DemoForm';
import Footer from './components/Footer';
import './App.css';

function App() {
  const [selectedPlan, setSelectedPlan] = useState(null);
  const formRef = useRef(null);

  const handleAddToCart = (plan) => {
    setSelectedPlan(plan);

    // Scroll to the form section
    if (formRef.current) {
      formRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <>
      <Header />
      <Hero />
      <Features />
      <Pricing addToCart={handleAddToCart} />
      <Testimonials />
      <FAQ />
      
      {/* Attach ref to DemoForm section */}
      <div ref={formRef}>
        <DemoForm selectedPlan={selectedPlan} />
      </div>

      <Footer />
    </>
  );
}

export default App;
